import React, { useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import {connect} from "react-redux";
import styles from "./EventGroupDetails.scss";
import Loader from "components/shared/elements/Loader";
import * as SiteActions from "actions/SiteActions";
import Calendar from "components/site/elements/Calendar";
import filter from "lodash/filter";
import map from "lodash/map";
import moment from "moment";
import EventCard from "components/site/elements/EventCard";
import Button from "../../shared/elements/Button";

function EventCaldendarDate(props) {
    const history = useHistory();

    useEffect(() => {
        window.scrollTo(0, 0);
        props.loadPublicEvents();
    }, []);

    if (!props.events) {
        return <Loader />
    }

    const renderUpcomingEvents = () => {
        return map(props.events, (event, indx) => (
            <EventCard event={event} key={`event_${indx}`}/>
        ));
    }

    const handleCalendarClick = (calendarDate) => {
        history.push(`/calendar/${moment(calendarDate).format("YYYY-MM-DD")}`)
    }

    const changeDay = (direction) => {
        let updatedDate = moment(props.selectedDate).add(1, 'day');
        if (direction === "prev") {
            updatedDate = moment(props.selectedDate).subtract(1, 'day');
        }
        history.push(`/calendar/${updatedDate.format('YYYY-MM-DD')}`);
    }

    return (
        <div className={styles.root}>
            <div className={styles.root}>
                <div className={styles.content}>
                    <div className={styles.mainContainer}>
                        <div className={styles.topText}>
                            <Link to={"/"}>
                                &lt; Back to All Classes & Events
                            </Link>
                        </div>
                        <h2>{props.selectedDate.format("MMMM DD, YYYY")}</h2>
                        <div className={styles.controls}>
                            <Button
                                onClick={() => changeDay('prev')}
                                buttonText={"Previous"}
                                buttonColor={"light"}
                                buttonIcon={"fas fa-chevron-left"}
                            />
                            <Button
                                onClick={() => changeDay('next')}
                                buttonText={"Next"}
                                buttonColor={"light"}
                                buttonIcon={"fas fa-chevron-right"}
                            />
                        </div>
                        <div className={styles.eventsContainer}>
                            {!Object.keys(props.events).length ? (
                                <h3>No events for the selected date</h3>
                            ):(
                                renderUpcomingEvents()
                            )}
                        </div>
                    </div>
                    <div className={styles.sidebarContent}>
                        <div className={styles.sidebarInner}>
                            <div className={styles.topText}>
                                    <Link to={"/"}>
                                        &lt; Back to All Classes & Events
                                    </Link>
                            </div>
                            <Calendar
                                selectedDate={props.selectedDate.toDate()}
                                onClick={handleCalendarClick}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(
    (state, ownProps) => {
        const selectedDate = moment(ownProps.match.params.date);
        const events = state.site.events;
        const filteredEvents = filter(events, event => {
            return selectedDate.isSame(event.eventDate, 'day');
        });
        return {
            events: filteredEvents,
            selectedDate,
        };
    },
    (dispatch) => ({
        loadPublicEvents: () => dispatch(SiteActions.loadPublicEvents()),
    })
)(EventCaldendarDate);
